import { h, render } from 'preact';

import '../sass/ticket_office.scss';
import { TicketOfficeState, TicketOfficeView } from '../types/ticket-office';
import { initBarcodeScanner } from './barcode_scanner_ticket_office';
import { TicketOffice } from './components/TicketOffice';
import { Api } from './props/api';
import { shouldShowGrid, updateCashierMonitor, updateLeftMenuVisibility } from './props/app/grid-view-utils';
import { getSeats } from './props/app/seat-utils';
import { getTicketOfficeProps } from './props/app/TicketOffice';

export const initTicketOffice = (): void => {
    const container = document.querySelector('.ticket-office');

    if (!container) {
        return;
    }

    const { defaultPaymentMethod } = window.initialTicketOfficeState;

    const state: TicketOfficeState = {
        ...window.initialTicketOfficeState,
        isGridView: shouldShowGrid(),
        seats: {
            sold: [],
            reserved: [],
            disabled: [],
            booked: [],
        },
        expandedTicketTypes: new Set(),
        seatUpdaterEnabled: true,
        pendingOps: new Set(),
        paymentMethod: defaultPaymentMethod,
        modalQuantity: 0,
        modalUnitPrice: 0,
        discountCodes: [],
        cashModal: {
            paidValue: 0,
            fieldValue: '0',
        },
    };

    const view: TicketOfficeView = {
        state,
        update: (): void => {
            const props = getTicketOfficeProps(view);
            render(h(TicketOffice, props), container);
        },
        timeouts: new Map(),
        stableCallbacks: {
            onSelectDiscount: (suggestion): void => {
                state.discountModalValue = suggestion
                view.update()
            },
        },
    };

    view.update(); // First render

    updateLeftMenuVisibility(state)
    updateCashierMonitor(state)

    $(window).on('beforeunload', (): void => {
        Api.getJson('/cashier/reset');
    });

    $('#products_modal').on('hide.bs.modal', () => $.post('/cashier/products/hide'));

    getSeats(view);

    initBarcodeScanner(view);
};
